import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';

const BulkPrachar = () => {
    const navigate = useNavigate();
    const { language , appId , userId } = useAppId();
    
    const lang = language || 'en';

    // --- Translation Dictionary ---
    const t = {
        en: {
            title: "Bulk Prachar",
            back: "Back to Dashboard",
            loadingText: "Loading Bulk Prachar Portal..."
        },
        hi: {
            title: "थोक प्रचार",
            back: "डैशबोर्ड पर वापस",
            loadingText: "थोक प्रचार पोर्टल लोड हो रहा है..."
        },
        gu: {
            title: "બલ્ક પ્રચાર",
            back: "ડેશબોર્ડ પર પાછા",
            loadingText: "બલ્ક પ્રચાર પોર્ટલ લોડ થઈ રહ્યું છે..."
        }
    };

    const txt = t[lang] || t.en;
    const TARGET_URL = `https://hlele.bjpwings.com/OtherPage/BulkPrachar?app_id=${appId}&uid=${userId}`; 

    return (
        // 🔴 FIX: p-4 અને paddingBottom કાઢી નાખ્યું જેથી iframe ની આસપાસ જગ્યા ન રહે
        <div className="app-container p-3 p-md-4" style={{ minHeight: '100vh', background: '#f4f7f9' }}>
            <Header title={txt.title} />
        
            
          

            {/* iFrame Container to show the external portal */}
            <div className="iframe-wrapper slide-up-element">
                
                {/* Background loading text */}
                {/* <div className="iframe-loading-indicator">
                    <div className="spinner"></div>
                    <span>{txt.loadingText}</span>
                </div> */}

                <iframe 
                    src={TARGET_URL} 
                    title="Bulk Prachar Portal"
                    className="responsive-iframe"
                    allowFullScreen
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                ></iframe>
                
            </div>

            <style jsx>{`
                .back-btn-modern {  
                    display: flex; align-items: center; 
                     background: #ffffff;
                   
                    color: #475569; font-weight: 600; font-size: 14px;
                    cursor: pointer; transition: all 0.2s ease;
                    
                }
                .back-btn-modern:hover { 
                    background: #f8fafc; border-color: #cbd5e1; transform: translateY(-1px); 
                    box-shadow: 0 4px 6px rgba(0,0,0,0.04);
                }

                .iframe-wrapper {
                    position: relative;
                    width: 100%;
                    /* 🔴 FIX: હેડરની હાઈટ બાદ કરી જેથી ડબલ સ્ક્રોલબાર ના આવે */
                    height:100vh; 
                    background: #ffffff;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .responsive-iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                    z-index: 10;
                    background-color: transparent;
                }

                /* Loading Indicator behind the iframe */
                .iframe-loading-indicator {
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    font-weight: 600;
                    font-size: 15px;
                    z-index: 1;
                }

                .spinner { 
                    width: 40px; 
                    height: 40px; 
                   
                    animation: spin 1s linear infinite; 
                 
                }

                .slide-up-element { 
                    animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
                    opacity: 0;
                }
                
                @keyframes slideUp { 
                    from { opacity: 0; transform: translateY(20px); } 
                    to { opacity: 1; transform: translateY(0); } 
                }
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); } 
                }

                /* Mobile Adjustments */
                @media (max-width: 768px) {
                    .iframe-wrapper {
                        height:100vh;
                    }
                }
            `}</style>
        </div>
    );
};

export default BulkPrachar;